import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { toTitleCase } from '../../../utils/toTitleCase'


const CLUB_URL = 'clubs'
const ADMIN_CLUB_URL = 'admin/auth/clubs'

const ViewClubs = () => {
    const [clubs, setClubs] = useState([])
    const [open, setOpen] = useState(false);
    const [selectedClub, setSelectedClub] = useState(null)
    const token = localStorage.getItem('token')

    const deleteClub = async (id) => {
        try {
            await axios.delete(`${process.env.REACT_APP_DEPT_API}/${ADMIN_CLUB_URL}/${id}/delete`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            })
            alert("Deleted successfully")
            setSelectedClub('')
            setOpen(false);
            window.location.reload(false)
        } catch (err) {
            console.log(err)
            alert("Error, check console logs")
        }
    }

    useEffect(() => {
        const getData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_DEPT_API}/${CLUB_URL}`)
                setClubs(response.data)
            } catch (err) {
                console.log(err)
                alert("Error, check console logs")
            }
        }
        getData()
        // eslint-disable-next-line
    }, [])


    const handleClickOpen = (fac) => {
        setSelectedClub(fac)
        setOpen(true);
    };

    const handleClose = () => {
        setSelectedClub('')
        setOpen(false);
    };

    const sortedClubs = clubs && clubs.sort((a, b) => a.order_no > b.order_no ? -1 : 1)

    return (
        <div className='admin'>
            <div className='section__container'>
                <div className='section'>
                    {selectedClub &&
                        <div>
                            <Dialog open={open} onClose={handleClose}>
                                <DialogTitle>
                                    <div>
                                        <h2>{toTitleCase(selectedClub && selectedClub.name)}</h2>
                                        <p>{selectedClub.email}</p>
                                    </div>
                                    <span className='admin_modal_header'>Confirm Delete</span>
                                </DialogTitle>
                                <DialogContent>
                                    <div className='modal_btn_container'>
                                        <button className='admin_modal_btn cancel' onClick={handleClose}>Cancel</button>
                                        <button className='admin_modal_btn delete' onClick={() => deleteClub(selectedClub._id)}>Delete</button>
                                    </div>
                                </DialogContent>
                            </Dialog>
                        </div>}
                    <h3 className='section__header'>Clubs</h3>
                    <Link to='register'>
                        <button className='admin_add_btn'>ADD</button>
                    </Link>
                    <div className='admin_toppers__container'>
                        {sortedClubs && sortedClubs.map(clb => (
                            <div key={clb._id} className='admin_toppers_card'>
                                <button className='admin_delete_btn' onClick={() => handleClickOpen(clb)}>X</button>
                                {clb.image && (
                                    <div className='admin_toppers_img'>
                                        <img src={clb.image && clb.image.url} alt="Topper" style={{ width: "100px" }} />
                                    </div>
                                )}
                                <h2>{toTitleCase(clb.name)}</h2>
                                <p>{clb.email}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewClubs